import script from "./ScalperList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScalperList.vue?vue&type=script&setup=true&lang=ts"

import "./ScalperList.vue?vue&type=style&index=0&id=2aeda2f6&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aeda2f6"]])

export default __exports__